module.exports = __webpack_public_path__ + "static/media/caribbean.0f40e26c.jpg";